import React from 'react'
import PropTypes from 'prop-types'

import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Divider,
  makeStyles,
} from '@material-ui/core'

import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons'

import useCollapse from 'hooks/useCollapse'
import styles from './styles'

const useStyles = makeStyles(styles)
const DefaultComponent = ({ children }) => <>{children}</>

const Collapse = ({
  collapseHeader,
  collapseBody,
  expansionPanelProps = {},
}) => {
  const classes = useStyles()
  const collapse = useCollapse()
  const CollapseHeader = collapseHeader || DefaultComponent
  const CollapseBody = collapseBody || DefaultComponent

  const handleChangeExpansionPanel = collapseId => (event, expand) => {
    collapse.setExpand(collapseId, expand)
  }

  return (
    <>
      {collapse.data.map(item => (
        <ExpansionPanel
          onChange={handleChangeExpansionPanel(item.collapseId)}
          expanded={item.collapseSettings.expand}
          key={item.collapseId}
          {...expansionPanelProps}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <CollapseHeader item={item} />
          </ExpansionPanelSummary>

          <Divider />

          <ExpansionPanelDetails className={classes.expansionPanelDetails}>
            <CollapseBody item={item} />
          </ExpansionPanelDetails>
        </ExpansionPanel>
      ))}
    </>
  )
}

Collapse.propTypes = {
  collapseHeader: PropTypes.func.isRequired,
  collapseBody: PropTypes.func.isRequired,
  expansionPanelProps: PropTypes.object,
}

export default Collapse
